import React, { FC, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Colors } from '../../styles/colors';
import { Icon } from './Icon';
import { Flexbox, FlexboxCenter } from './Layout';

const Container = styled(Flexbox)`
  background-color: ${`${Colors.grayDark}E5`};

  .app & {
    margin: -2rem -2rem 2rem;
  }

  padding: 0 2rem;
  color: ${Colors.white};

  transition: max-height 150ms ease-out;
  max-height: ${(props) => props['open'] ? '5rem' : '0'};
  overflow: hidden;
  
  &.error {
     background-color: ${Colors.error};
  }
`;

const AlertIconWrapper = styled(FlexboxCenter)`
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 100%;
  background-color: ${Colors.secondary};
  padding: .375rem;
  font-size: 1.5rem;
  margin: 1rem 1rem 1rem 0;
  
    &.error {
      background-color: ${Colors.errorLight};
    }
  }
`;

const FormText = styled.p`
  flex: 1;
  margin: 0 0 0 2rem;

  font-size: .875rem;
  line-height: 1.21;

  a {
    text-decoration: underline;
  }
`;

const CloseButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 1.5rem;

  button:hover {
    @media (pointer: fine) {
      color: ${Colors.tertiary};
    }
  }
`;

export interface NotificationBannerProps {
  open: boolean;
  onClose: () => void;
  renderContent?: () => React.ReactNode;
  error?: boolean;
}

export const NotificationBanner: FC<NotificationBannerProps> = (props) => {
  const { open, onClose, renderContent, error = false } = props;
  const bannerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (open === true) {
      if (bannerRef && bannerRef.current) {
        window.scrollTo({
          behavior: 'smooth',
          top: 0,
        });
      }
    }
  }, [open]);

  return (
    <Container ref={bannerRef} {...{ open }} className={`${error ? 'error' : ''}`}>
      <AlertIconWrapper className={`${error ? 'error' : ''}`}>
        <Icon icon={'info-circle'} size={24}/>
      </AlertIconWrapper>
      <FormText>
        {
          renderContent && renderContent()
        }
      </FormText>
      <CloseButton onClick={() => onClose && onClose()}>
        <Icon icon={'state-error'} size={24}/>
      </CloseButton>
    </Container>
  );
};
